export const AUTOMATION_TRIGGERS_LIST = 'AUTOMATION_TRIGGERS_LIST'
export const AUTOMATION_TRIGGERS_LIST_PENDING = 'AUTOMATION_TRIGGERS_LIST_PENDING'
export const AUTOMATION_TRIGGERS_LIST_FULFILLED = 'AUTOMATION_TRIGGERS_LIST_FULFILLED'
export const AUTOMATION_TRIGGERS_LIST_REJECTED = 'AUTOMATION_TRIGGERS_LIST_REJECTED'

export const AUTOMATION_TRIGGERS_CONSTANTS = 'AUTOMATION_TRIGGERS_CONSTANTS'
export const AUTOMATION_TRIGGERS_CONSTANTS_PENDING = 'AUTOMATION_TRIGGERS_CONSTANTS_PENDING'
export const AUTOMATION_TRIGGERS_CONSTANTS_FULFILLED = 'AUTOMATION_TRIGGERS_CONSTANTS_FULFILLED'
export const AUTOMATION_TRIGGERS_CONSTANTS_REJECTED = 'AUTOMATION_TRIGGERS_CONSTANTS_REJECTED'
